var map = {
	"./category-anatomy.svg": 1398,
	"./category-case.svg": 9999,
	"./category-causal-disease.svg": 573,
	"./category-causal-gene.svg": 6400,
	"./category-cell-line.svg": 2184,
	"./category-correlated-disease.svg": 9354,
	"./category-correlated-gene.svg": 9537,
	"./category-disease.svg": 2067,
	"./category-function.svg": 4378,
	"./category-gene.svg": 6970,
	"./category-genotype.svg": 6225,
	"./category-homolog.svg": 5532,
	"./category-interaction.svg": 6906,
	"./category-model.svg": 5913,
	"./category-ortholog-disease.svg": 7784,
	"./category-ortholog-phenotype.svg": 2760,
	"./category-pathway.svg": 6726,
	"./category-phenotype.svg": 5962,
	"./category-publication.svg": 8789,
	"./category-unknown.svg": 7884,
	"./category-variant.svg": 3767,
	"./knowledge-graph.svg": 2506,
	"./loading.svg": 659,
	"./phenotype-search.svg": 5899,
	"./toolbox.svg": 3393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;